import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColorSquareComponent } from './color-square.component';
import { AdjustColorModule } from '../../../directives/adjust-color/adjust-color.module';

@NgModule({
    declarations: [
        ColorSquareComponent,
    ],
    imports: [
        CommonModule,
        AdjustColorModule,
    ],
    exports: [
        ColorSquareComponent,
    ]
})
export class ColorSquareModule { }
